import { Authenticator, Heading, Input, Label, SelectField } from "@aws-amplify/ui-react";
import { Box, Typography, useTheme } from "@mui/material";
import { signUp } from "aws-amplify/auth";
import { formFields } from "src/config";
import useAppContext from "src/hooks/useAppContext";


export default function Auth() {
  const { deliveryStatus } = useAppContext();

  const services = {
    async handleSignUp(input) {
      const { username, password, options } = input;
      // const customEmail = options?.userAttributes?.email.toLowerCase();
      return signUp({
        username,
        password,
        options: {
          ...options,
          userAttributes: {
            ...input.options?.userAttributes,
            address: `${input.options?.userAttributes?.['custom:street']}, ${input.options?.userAttributes?.['custom:district']}`,
          },
        },
      });
    },
    validateCustomSignUp: async (formData) => {
      const errors = {}
      if (formData.name && formData.name.split(' ').length < 2) {
        errors.name = 'Informe nome e sobrenome';
      }

      return errors;
    }
  };

  const components = {
    Header() {
      return (
        <Box sx={{ mt: 8 }} />
      );
    },

    ConfirmResetPassword: {
      Header() {
        const theme = useTheme();
        return (
          <Heading
            padding={`2 0 0 0`}
            level={3}
          >
            Redefinir senha
            <Typography variant='body1' sx={{ mt: 2 }} color={theme.palette.grey[700]}>
              Um código de confirmação foi enviado para o seu email.
              Insira-o no campo abaixo e defina uma nova senha.
            </Typography>
          </Heading>
        );
      },
    },

    SignUp: {
      FormFields() {
        return (
          <>
            {/* Re-use default `Authenticator.SignUp.FormFields` */}
            <Authenticator.SignUp.FormFields />

            <SelectField
              label="Bairro"
              id="custom:district"
              name="custom:district"
              placeholder="Selecione o bairro"
              isRequired
            >
              {deliveryStatus?.districts?.map(e =>
                <option key={e.name} value={e.name}>{e.name}</option>
              )}
            </SelectField>

            <span>
              <Label htmlFor="custom:ref">Referência</Label>
              <Input isRequired id='custom:ref' name='custom:ref' placeholder="Forneça um ponto de referência" style={{ marginTop: '8px' }} />
            </span>
          </>
        );
      },
    },
  }

  return (
    <Authenticator formFields={formFields} services={services} components={components} loginMechanisms={['email']}>
      Carregando...
    </Authenticator>
  )
}